/* eslint-disable no-useless-concat */
import React, { useState, useEffect } from "react";
import Pagination from "../../../../services/Pagination";
import ExcelServices from "../../../../services/ExcelServices";
import { format } from "date-fns";
const dateFormat = "dd-MM-yyyy";

const TwomtwoPaymentsByDate = ({ payments, setState }) => {
	useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);
    
   
	var curr = new Date();
	curr.setDate(curr.getDate());
	var date = curr.toISOString().substring(0, 10);

	const [searchByDate, setSearchByDate] = useState(false);
	const [paymentsByDate, setPaymentsByDate] = useState([]);

	const [begin_date, setBeginDate] = useState(date);
	const [end_date, setEndDate] = useState(date);

	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(20);

	const handleSearch = async (e) => {
		e.preventDefault();
	
		// Filter payments by date range
		const requestData = payments?.filter(
			(payment) =>
				payment.payment_date >= begin_date &&
				payment.payment_date <= end_date
        );   
		setPaymentsByDate(requestData);
		setSearchByDate(true);
	};

	const handleBack = () => {
		setSearchByDate(false);
	};
    let total_payments = 0;
    const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;
	let currentPosts = [];
	if (paymentsByDate.length > 0) {
		currentPosts = paymentsByDate?.slice(
			indexOfFirstPage,
			indexOfLastPage
        );
      
        for (var i = 0; i < paymentsByDate?.length; i++) {
            total_payments += paymentsByDate[i].payment_amount;
        }
	}


    const handleByDateExcel = () => {
        // let total_amount_paid = 0;
	let paymentData = [];
	for (var i = 0; i < paymentsByDate?.length; i++) {
		// total_amount_paid += paymentsByDate[i].payment_amount;
		paymentData.push({
			serial_no: i + 1,
			year: paymentsByDate[i].year,
			pf_number: paymentsByDate[i].pf_number,
			full_name:
				paymentsByDate[i].members?.first_name +
				" " +
				paymentsByDate[i].members?.middle_name +
				" " +
				paymentsByDate[i].members?.last_name,
			mobile_number: paymentsByDate[i].mobile_number,
			payment_amount: paymentsByDate[i].payment_amount,
			payment_date: paymentsByDate[i].payment_date,
		});
        }
       
        let filename = `2M2_Payments_${begin_date} - ${end_date}.xlsx`;
	const headings = [
		[
			"SERIAL NO.",
			"YEAR",
			"PF NUMBER",
			"FULL NAME",
			"MOBILE NUMBER",
			"AMOUNT",
			"PAYMENT DATE",
		],
	];
        
		ExcelServices({ headings, paymentData, filename });
	};

	
	const handleCancel = () => {
		setBeginDate(date);
		setEndDate(date);
		setPaymentsByDate({});
		setSearchByDate(false);
		setState((prevState) => ({
			...prevState,
			isByDate: false,
			isByMonth: false,
			isAll: true,
		}));
	};

	const searchContent = (
		<>
			<form onSubmit={handleSearch}>
				<div className="form-group row">
					<label
						style={{ fontSize: 16, width: "15%" }}
						htmlFor="begin_date"
						className="col-sm-2"
					>
						Begin Date:
					</label>
					<div className="col-sm-2">
						<input
							type="date"
							id="begin_date"
							style={{ fontSize: 16 }}
							onChange={(e) => setBeginDate(e.target.value)}
							required
							value={begin_date}
							className="form-control"
						/>
					</div>
					<label
						style={{ fontSize: 16, width: "10%" }}
						htmlFor="end_date"
						className="col-sm-2"
					>
						End Date:
					</label>
					<div className="col-sm-2">
						<input
							type="date"
							id="end_date"
							style={{ fontSize: 16 }}
							onChange={(e) => setEndDate(e.target.value)}
							required
							value={end_date}
							className="form-control"
						/>
					</div>

					<div className="col-sm-2">
						<button
							type="submit"
							className="btn btn-success btn-block "
						>
							{" "}
							<i className="fa fa-search"></i> Search
						</button>
					</div>
					<div className="col-sm-2">
						<button
							onClick={handleCancel}
							className="btn btn-danger btn-block"
						>
							Cancel
						</button>
					</div>
				</div>
			</form>
		</>
	);

	const content =
    paymentsByDate?.length > 0 && searchByDate && (
			<>
				<div>
					<button
						onClick={handleByDateExcel}
						className="btn btn-success"
					>
						<i className="fa fa-upload"></i>&nbsp; &nbsp;Generate
						Excel File
					</button>
					&nbsp; &nbsp;
				</div>
				<hr />
				<div className="table-responsive lg">
                    <table className="table table-borderless table-striped">
					<caption className="table-caption">
						{" "}
						2M2 PAYMENTS {" - "}
						{format(new Date(begin_date), dateFormat)}
						{" to "} {format(new Date(end_date), dateFormat)}{" - "}
						<strong style={{ color: "var(--green)" }}>
							GHS
							{total_payments.toLocaleString(undefined, {
								minimumFractionDigits: 2,
							})}
						</strong>
					</caption>

						<thead>
							<tr>
								<th scope="col">#</th>
								<th scope="col">Year</th>
								<th>PF Number</th>
								<th>Full Name</th>
                                <th>Mobile Number</th>
                                <th scope="col">Payment Date</th>
								<th style={{ textAlign: "right" }}>
									Amount Paid
								</th>
								
							</tr>
						</thead>
						<tbody>
							{currentPosts?.map((mem, index) => (
								<tr key={mem.id}>
									<td style={{ textAlign: "center" }}>
										{postPerPage * (currentPage - 1) +
											index +
											1}
									</td>
									<td>{mem.year}</td>
									<td>{mem.pf_number}</td>
                                    <td>
                                        {mem.members?.first_name+" "+mem.members?.middle_name+" "+mem.members?.last_name}
                                    </td>
                                    <td>{mem.mobile_number}</td>
                                    <td>{mem.payment_date}</td>
									<td style={{ textAlign: "right" }}>
										{mem.payment_amount.toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}
									</td>
									
								</tr>
							))}
						</tbody>
						<tbody>
							<tr>
								<th
									colSpan={"6"}
									style={{
										fontSize: "16px",
										fontWeight: "900",
										color: "white",
									}}
								>
									TOTAL 2M2 PAYMENTS - {begin_date+" to "+end_date}
								</th>
								<th
									style={{
										fontSize: "16px",
										fontWeight: "900",
										color: "white",
										textAlign: "right",
									}}
								>
									{total_payments.toLocaleString(
										undefined,
										{ minimumFractionDigits: 2 }
									)}
								</th>
								<th></th>
							</tr>
						</tbody>
					</table>
				</div>
			</>
		) 

	return (
		<>
            {!searchByDate ? 
                searchContent
             : 
			paymentsByDate.length > 0 ? (
				<>
					<div className="panel-body">{content}</div>
					<div className="panel-footer">
						<Pagination
							data={paymentsByDate}
							postPerPage={postPerPage}
							currentPage={currentPage}
							setCurrentPage={setCurrentPage}
							setPostPerPage={setPostPerPage}
						/>
					</div>
					<div className="box-footer">
						<div className="col-sm-2">
							<button
								onClick={handleBack}
								className="btn btn-success"
							>
								Cancel
							</button>
						</div>
					</div>
				</>
			):(
				<>
					<div className="panel-body">
						<h4>
							No payment transactions between{" "}
							{<b>{begin_date}</b>} and {<b>{end_date}</b>}
						</h4>
					</div>
					<div className="box-footer">
						<div className="col-sm-2">
                            <button
                                type="button"
								onClick={handleBack}
								className="btn btn-success"
							>
								Cancel
							</button>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default TwomtwoPaymentsByDate;
